export function nodeListToArray(nodeList: NodeList): HTMLElement[] {
	return [].slice.call(nodeList);
}

export function getTagNameFromNodeList(nodeList: NodeList): string | null {
	let tagName: string | null = null;

	for (var i = 0; i < nodeList.length && tagName === null; i += 1) {
		const nodeName = nodeList[i].nodeName.toLowerCase();
		if (nodeName != '#text') {
			tagName = nodeName;
		}
	}

	return tagName;
}
